export const config = {
    productCode: {
        tp: 'MotorImtiazeTP',
        sp: 'PRMotorImtiazeSP',
        co: 'PRMotorImtiazeCO',
    },
    paymentOptions:{
        SADAD: 'sadad',
        CREDIT_CARD:'cc',
        TAMARA:'tamara',
        APPLE: 'apple'
    },
    apiUrl: process.env.REACT_APP_API_URL,
    otpPeriod:  5 * 60,
    redirectDomainUrl:process.env.REACT_APP_REDIRECT_URL,
    prefixRouting:process.env.REACT_APP_PREFIX_ROUTING
};